import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu.component';
import { RouterModule } from '@angular/router';
import { UserProfileAvatarModule } from '../user-profile-avatar/user-profile-avatar.module';
import { BgRecentVisitsService } from '../../services/bg-recent-visits.service';

@NgModule({
  declarations: [MenuComponent],
  imports: [
    CommonModule,
    RouterModule,
    UserProfileAvatarModule
  ],
  exports: [MenuComponent],
  providers: [BgRecentVisitsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MenuModule { }
